import React, { useContext, useState } from 'react';
import { ThemeContext } from 'context/themeContext';
import {
  OrderWrapper,
  OrderWrapperBox,
  OrderRightSide,
  OrderLeftSide,
  Ordertext,
  CancelIcon,
  ButtonWrapper,
  DeleteWrapper,
} from './style';
import QuantityBox from './order-quantity';
import Currency from 'components/currency';
import MainContext from 'MainContext';
import * as API from '../container/api';
import styled from 'styled-components';
import Button from 'components/button';
import { useTranslation } from 'react-i18next';
import HalfImagePlaceholder from '../../../asset/half-image-placeholder.svg';

const Image = styled.img.attrs({
  src: HalfImagePlaceholder,
})`
  position: absolute;
  top: 0;
  left: ${(props) => (props.rtlDirection ? 'unset' : '0')};
  right: ${(props) => (props.rtlDirection ? '0' : 'unset')};
  width: 9.37vw;
  height: 100%;
  object-fit: cover;
`;

const BasketOrder = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { basketOrders, setCartContext } = useContext(MainContext).cart;
  const { updateToasterContext } = useContext(MainContext).toasters;
  const [deleteStatus, setDeleteStatus] = useState(false);
  const { t } = useTranslation();
  const { deleteInvoiceOrder, invoiceId, order, getOrderMaterialAndColor } = props;
  const updateCartOrders = () => {
    let helper = [...basketOrders];
    basketOrders.map((basketOrder, index) => {
      if (basketOrder._id === order._id) {
        helper.splice(index, 1);
      }
    });
    setCartContext(helper);
  };

  const onDeletClick = async () => {
    await API.deleteBasketOrder(order._id);
    if (invoiceId) {
      deleteInvoiceOrder(order._id);
    } else {
      updateCartOrders();
    }
  };

  return (
    <OrderWrapper theme={theme}>
      <CancelIcon
        className="icon-cancel-button"
        theme={theme}
        rtlDirection={rtlDirection}
        display={!deleteStatus}
        onClick={() => setDeleteStatus(true)}
      />
      <OrderWrapperBox rtlDirection={rtlDirection} theme={theme}>
        {order.file.image_path === 'default image path' ? (
          <Image rtlDirection={rtlDirection} theme={theme} />
        ) : (
          <OrderLeftSide
            rtlDirection={rtlDirection}
            src={
              `${process.env.REACT_APP_STATISTIC_SERVICE_URL}/stl` +
              order.file.image_path +
              `?${new Date().getTime()}`
            }
          />
        )}
        <OrderRightSide rtlDirection={rtlDirection}>
          <Ordertext
            rtlDirection={rtlDirection}
            theme={theme}
            top="0.895vw"
            left="1.04vw"
            fontSize="0.728vw"
            width="8.328vw"
          >
            {order.file.original_name}
          </Ordertext>
          <Ordertext
            rtlDirection={rtlDirection}
            theme={theme}
            top="2.654vw"
            left="1.04vw"
            fontSize="0.624vw"
            // width="8.328vw"
            width="7.328vw"
          >
            {getOrderMaterialAndColor(order)}
          </Ordertext>
          <Ordertext
            rtlDirection={rtlDirection}
            theme={theme}
            top="5.257vw"
            right="1.04vw"
            fontSize="0.858vw"
          >
            {/* <Currency value={order.price} /> this is changed to below one by qazal instead of the above line for preventing of floating point */}
            { order.status !== 9 ? 
              <Currency value={Number.isInteger(order.price) ? order.price : parseFloat( order.price ).toFixed(2)} /> : "RFQ"
            }
          </Ordertext>
          <QuantityBox quantity={order.quantity} id={order._id} invoiceId={invoiceId} />
        </OrderRightSide>
        <DeleteWrapper theme={theme} display={deleteStatus}>
          {t('cart.order.Are you sure to delete this product?')}
          <ButtonWrapper>
            <Button
              onClick={() => setDeleteStatus(false)}
              marginTop={0}
              text={t('cart.order.No')}
              size="small"
            />
            <Button
              onClick={onDeletClick}
              marginTop={0}
              text={t('cart.order.Yes')}
              size="small"
              type="secondary"
            />
          </ButtonWrapper>
        </DeleteWrapper>
      </OrderWrapperBox>
    </OrderWrapper>
  );
};

export default BasketOrder;
